export function ConverterData(data) {
    const partes = data.split('/');
    return new Date(partes[2], partes[1] - 1, partes[0]);
}

export function CalcularDias(dataInicio, dataFim) {
    if (dataInicio && dataFim) {
      const inicio = ConverterData(dataInicio);
      const fim = ConverterData(dataFim);

      // Verificar se a data de fim é válida
      if (isNaN(inicio) || isNaN(fim)) {
        alert('Data inválida!');
        return;
      }

      // Calcular a diferença em milissegundos
      const diffEmMilissegundos = fim - inicio;

      // Converter a diferença de milissegundos para dias
       return Math.ceil(diffEmMilissegundos / (1000 * 60 * 60 * 24)); // ceil para arredondar para cima
    }
  }